import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
declare global {
  interface Window {
    IntersectionObserver: IntersectionObserver;
    IntersectionObserverEntry: IntersectionObserverEntry;
  }
}

export type StoryType = {
  title: string
  intro?: string
  button_text?: string
  button_url?: string
}

export type StoryBlockProps = {
  blocks: StoryType[]
}

export type StoryBlockStyle = Partial<{
}>

export function StoryBlock<customBlockData, extra_images>(
  props: StoryBlockProps,
  options?: { style?: StoryBlockStyle; key?: string }
  ): (s:CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData,extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData,extra_images, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: _ => (
        <StoryBlockComponent {...props} />
      )
    })
}

type StoryBlockState = {
  currentBlock: number
  isInView: boolean
}

class StoryBlockComponent extends React.Component<StoryBlockProps, StoryBlockState> {
  
  private percentages: Map<number, number>

  constructor(props: StoryBlockProps) {
    super(props)
    this.state = {
      currentBlock: 0,
      isInView: false,
    }

    this.percentages = new Map<number, number>([[0, 0], [1, 0], [2, 0], [3, 0]])
  
  }

  checkCurrentBlock() {
    
    const blockOne = this.percentages.get(0);
    const blockTwo = this.percentages.get(1);
    const blockThree = this.percentages.get(2);
    const blockFour = this.percentages.get(3);

    if((blockOne || blockTwo || blockThree || blockFour) > 0) {

      if ((blockOne > blockTwo && blockOne > blockThree && blockOne > blockFour) && this.state.currentBlock != 0) {
        this.setState({
          ...this.state,
          currentBlock: 0
        })
      }

      if ((blockTwo > blockOne && blockTwo > blockThree && blockTwo > blockFour) && this.state.currentBlock != 1) {
        this.setState({
          ...this.state,
          currentBlock: 1
        })
      }

      if ((blockThree > blockOne && blockThree > blockTwo && blockThree > blockFour) && this.state.currentBlock != 2) {
        this.setState({
          ...this.state,
          currentBlock: 2
        })
      }

      if ((blockFour > blockOne && blockFour > blockTwo && blockFour > blockThree) && this.state.currentBlock != 3) {
        this.setState({
          ...this.state,
          currentBlock: 3
        })
      }      
    }
  }

  checkPercentageInView(blocks : HTMLDivElement[]) {
    if(blocks[0] && blocks[0].getBoundingClientRect()) {
      blocks.map((block, index) => {
        if (window.IntersectionObserver && window.IntersectionObserverEntry) {
          var observer = new IntersectionObserver(changes => {
            for (const change of changes) {
              this.percentages.set(index, change.intersectionRatio * 100)
              this.checkCurrentBlock()
            }
          }, {
            threshold: Array.from(new Array(100), (x, i) => i * 0.01)
          });

          observer.observe(block);
        }
      })
    }
  }

  componentDidMount() {
    const StoriesList : HTMLDivElement[] = [this[`story-0`], this[`story-1`], this[`story-2`], this[`story-3`]];
    this.checkPercentageInView(StoriesList)
  } 

  render() {
    return(
      <section className="block block--story">
          <div className="block__inner">

          <div className={`story__visual story__visual--${this.state.currentBlock}`}>
            <figure>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 202 246">
                <polygon id="yellow" points="101 164 101 246 117.872 246 185.126 246 202 246 202 164 101 164" style={{fill: "#FFAB00", fillRule: "evenodd" }} />
                <path id="pink" d="M0,164c.79824,0,1.26762.00949,3.05245,0,17.22548-.11017,65.15885,35.11178,83.71473,49.54361,6.61714,5.14368,13.8631,12.72059,14.07237,21.0514.1475,5.83675.16045,7.39342.16045,11.40525L0,246Z" style={{ fill: "#fcd6d1", fillRule: "evenodd"}} />
                <path id="blue" d="M101,82v55.50332A26.47844,26.47844,0,0,0,127.45957,164H202V82Z" style={{fill: "#14335e", fillRule: "evenodd"}} />
                <path id="brown" d="M101,82v55.50332A26.47908,26.47908,0,0,1,74.54043,164H0V82Z" style={{ fill: "#380d12", fillRule: "evenodd" }} />
                <path id="salmon" d="M101,0V82h16.76108a33.73845,33.73845,0,1,1,67.47684,0H202V0Z" style={{fill: "#ffb08a", fillRule: "evenodd"}} />
                <path id="red" d="M101,0c-.79824,0-1.26762.01246-3.05245,0C80.72207-.10721,32.7877,35.11375,14.23282,49.54359,7.61469,54.69026.36972,62.26617.16045,70.595.012,76.43175,0,77.9914,0,82.00024l101-.01795Z" style={{fill: "#fc3d2e", fillRule: "evenodd"}} />
              </svg>
            </figure>

          </div>

          <div className="story__stories">
          
            {this.props.blocks.map((b, index) => {

              return <div key={index + "-story-block-component"} ref={ref => (this[`story-${index}`] = ref)}><Story {...b} index={index} /></div>
              
            })}

          </div>

          </div>
      </section>
    )
  }
}

export function Story(props: StoryType & { index: number }): JSX.Element {
  return (
    <article className="story" key={props.index}>
      <div className="story__inner">
        <div className="story__content">
          <header className="story__header">
            {props.index == 0 ? (
              <h2 className="story__title story__title--big" dangerouslySetInnerHTML={{__html: props.title}}></h2>
            ) : (
              <h3 className="story__title" dangerouslySetInnerHTML={{__html: props.title}}></h3>
            )}
          </header>

          {props.intro && (
            <div className="story__intro text--styled" dangerouslySetInnerHTML={{__html: props.intro}} />
          )}

          {props.button_text && props.button_url && (
            <footer className="story__footer">
              <a href={props.button_url} className="btn btn--secondary">{props.button_text}</a>
            </footer>
          )}
        </div>
      </div>
    </article>
  );
}


// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/storyBlock.tsx